<template>
    <div class="dispositivos-pruebas">
        <div style="background: #607D8B; color: #fff; padding: 5px 10px; border-bottom: 1px solid #122940">
            <el-row :gutter="20">
                <el-col :sm="12" :offset="0">
                    <h4 style="margin:10px 20px">DISPOSITIVOS MÉDICOS / PRUEBAS</h4>
                </el-col>

            </el-row>
        </div>
        <div class="pruebas-content">
            <el-table :data="pruebas" style="width: 100%" size="mini" fit border :loading="loading"
                height="calc(100vh - 50px)">
                <el-table-column prop="numero_os" label="N° de orden" width="100"></el-table-column>
                <el-table-column prop="hr" label="HR" width="80"></el-table-column>
                <el-table-column prop="lineas" label="lineas" width="60"></el-table-column>
                <el-table-column prop="remito" label="Remito" width="120"></el-table-column>
                <el-table-column prop="paciente_nombre" label="Paciente"></el-table-column>

                <el-table-column prop="medico_nombre" label="Médico" width="250"></el-table-column>
                <el-table-column prop="telefono" label="Teléfono" width="150">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.telefono" :disabled="scope.row.id_wc > 0" size="mini" placeholder="Teléfono" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="number_case" label="Caso Wise" width="100"></el-table-column>
                <el-table-column label="Acciones" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" :disabled="scope.row.id_wc > 0" :loading="creando"
                            @click="crearCasoPrueba(scope.row)">Crear Caso</el-button>
                        <el-button type="danger" size="mini" @click="verDetalle(scope.row)">Ver</el-button>

                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- Diálogo para mostrar detalles -->
        <el-dialog title="Detalles de la Prueba" :visible.sync="dialogVisible" width="80%" top="1vh"
            :before-close="handleClose">
            <div v-if="pruebaSeleccionada">
                <el-descriptions :column="2" border>

                    <el-descriptions-item label="Remito">{{ pruebaSeleccionada.remito }}</el-descriptions-item>
                    <el-descriptions-item label="N° de Orden">{{ pruebaSeleccionada.numero_os }}</el-descriptions-item>
                    <el-descriptions-item label="Fecha">{{ pruebaSeleccionada.fecha || 'No disponible'
                        }}</el-descriptions-item>
                    <el-descriptions-item label="Teléfono">{{ pruebaSeleccionada.telefono || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Tipo de Teléfono">{{ pruebaSeleccionada.telefono_tipo || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Cliente ID">{{ pruebaSeleccionada.cliente_id }}</el-descriptions-item>
                    <el-descriptions-item label="Médico">{{ pruebaSeleccionada.medico_nombre }}</el-descriptions-item>
                    <el-descriptions-item label="Email Médico">{{ pruebaSeleccionada.medico_email || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Paciente">{{ pruebaSeleccionada.paciente_nombre }}</el-descriptions-item>
                    <el-descriptions-item label="Caso Wise">{{ pruebaSeleccionada.number_case || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="ID WC">{{ pruebaSeleccionada.id_wc || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Estado WC">{{ pruebaSeleccionada.wc_status || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Creado">{{ pruebaSeleccionada.created_at || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Prueba">{{ pruebaSeleccionada.prueba }}</el-descriptions-item>
                    <el-descriptions-item label="Multiple">{{ pruebaSeleccionada.multiple || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Mensaje Recibido">{{ pruebaSeleccionada.mensaje_recibido || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Mensaje Leído">{{ pruebaSeleccionada.mensaje_leido || 'No disponible' }}</el-descriptions-item>
                    <el-descriptions-item label="Mensaje Enviado">{{ pruebaSeleccionada.mensaje_enviado || 'No disponible' }}</el-descriptions-item>
                </el-descriptions>

                <el-divider content-position="left">Dirección de Entrega</el-divider>
                <el-card class="box-card">
                    <div style="white-space: pre-line;">{{ procesarSaltosLinea(pruebaSeleccionada.direccion_entrega) ||
                        'No disponible' }}</div>
                </el-card>

                <el-divider content-position="left">Mensaje</el-divider>
                <el-card class="box-card">
                    <div style="white-space: pre-line;">{{ procesarSaltosLinea(pruebaSeleccionada.mensaje) || 'No disponible' }}</div>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cerrar</el-button>
            </span>
        </el-dialog>

        <!-- Modal para mostrar respuestas del servidor -->
        <el-dialog :title="respuestaModal.titulo" :visible.sync="respuestaModal.visible" width="60%" top="5vh">
            <div>
                <el-alert :title="respuestaModal.titulo" :type="respuestaModal.esError ? 'error' : 'success'"
                    :description="respuestaModal.descripcion" show-icon :closable="false">
                </el-alert>

                <el-divider content-position="left">Datos de Respuesta</el-divider>
                <el-card class="box-card">
                    <pre
                        style="background: #f5f5f5; padding: 15px; border-radius: 4px; overflow-x: auto; white-space: pre-wrap;">{{ JSON.stringify(respuestaModal.datos, null, 2) }}</pre>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="respuestaModal.visible = false">Cerrar</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {DM , HTTP} from '@/axios'
export default {
    name: 'DispositivosPruebas',
    data() {
        return {
            pruebas: [],
            loading: false,
            dialogVisible: false,
            pruebaSeleccionada: null,
            creando: false,
            respuestaModal: {
                visible: false,
                titulo: '',
                descripcion: '',
                datos: null,
                esError: false
            }
        }
    },
    mounted() {
        this.getPruebas()
    },
    methods: {
        getPruebas() {
            this.loading = true
            HTTP.get(DM + '/getCasosPruebasDM').then(res => {
                this.pruebas = res.data
                this.loading = false
            })
        },
        ejecutarPrueba(prueba) {
            console.log('Ejecutar prueba:', prueba)
        },
        verResultado(prueba) {
            console.log('Ver resultado:', prueba)
        },
        crearCasoPrueba(prueba) {
            this.creando = true
           HTTP.post(DM + '/crearCasoPruebaDM', {
               id: prueba.id,
               id_wc: prueba.id_wc,
            telefono: prueba.telefono,
            numero_os: prueba.numero_os,
            remito: prueba.remito,
            medico_nombre: prueba.medico_nombre,
           }).then(res => {
            this.creando = false
               if (!res.data.error) {
                this.$message.success('Caso creado correctamente')
                // Mostrar respuesta exitosa en modal
                this.mostrarRespuestaModal('Respuesta Exitosa', res.data, false)
            } else {
                this.$message.error('Error al crear el caso')
                // Mostrar error en modal
                this.mostrarRespuestaModal('Error en Respuesta', res.data, true)
            }
           })
           .catch(err => {
            this.creando = false
            this.$message.error('Error al crear el caso ' + err)
            // Mostrar error de catch en modal
            this.mostrarRespuestaModal('Error de Conexión', err, true)
           })
        },
        verDetalle(prueba) {
            this.pruebaSeleccionada = prueba
            this.dialogVisible = true
        },
        handleClose(done) {
            this.dialogVisible = false
            this.pruebaSeleccionada = null
            done()
        },
        procesarSaltosLinea(texto) {
            if (!texto) return null
            return texto.replace(/\\n/g, '\n')
        },
        mostrarRespuestaModal(titulo, datos, esError = false) {
            this.respuestaModal.titulo = titulo
            this.respuestaModal.datos = datos
            this.respuestaModal.esError = esError
            this.respuestaModal.descripcion = esError ? 
                'Se ha producido un error en la operación' : 
                'La operación se ha completado exitosamente'
            this.respuestaModal.visible = true
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-pruebas {
    padding: 0px;
    
    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }
    
    .pruebas-content {
    padding: 0px;
        .el-card {
            margin-bottom: 20px;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);
            
            :deep(.el-card__header) {
                background-color: var(--color-surface-base);
                border-bottom: 1px solid var(--color-border);
                border-radius: var(--radius-md) var(--radius-md) 0 0;
                
                span {
                    color: var(--color-primary);
                    font-weight: 500;
                }
            }
            
            :deep(.el-table) {
                .el-table__header-wrapper {
                    .el-table__header {
                        th {
                            background-color: var(--color-surface-alt);
                            color: var(--color-primary);
                            font-weight: 500;
                        }
                    }
                }
                
                .el-table__body-wrapper {
                    .el-table__body {
                        td {
                            color: var(--color-surface-muted);
                        }
                    }
                }
            }
            
            :deep(.el-button--mini) {
                border-radius: var(--radius-sm);
                
                &.el-button--default {
                    background-color: var(--color-btn-primary);
                    border-color: var(--color-btn-primary);
                    color: white;
                    
                    &:hover {
                        background-color: var(--color-primary-hover);
                        border-color: var(--color-primary-hover);
                    }
                }
                
                &.el-button--info {
                    background-color: var(--color-btn-primary);
                    border-color: var(--color-btn-primary);
                    color: white;
                    
                    &:hover {
                        background-color: var(--color-primary-hover);
                        border-color: var(--color-primary-hover);
                    }
                }
            }
        }
    }
}
</style> 